import { UidAndMessage } from "../features/chats/ChatTypes";
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { ServiceStatus } from "../features/maintenance/ServiceStatusCards";

// export const getFileIcon = (filename?: any): any => {
//   if (!filename) return "/icons/myfiles/file.svg";

//   const ext = filename.toLowerCase().split(".").pop();

//   switch (ext) {
//     case "pdf":
//       return "/icons/myfiles/pdf.svg";
//     case "doc":
//     case "docx":
//       return "/icons/myfiles/word.svg";
//     case "ppt":
//     case "pptx":
//       return "/icons/myfiles/ppt.svg";
//     case "xls":
//     case "xlsx":
//       return "/icons/myfiles/excel.svg";
//     case "txt":
//       return "/icons/myfiles/txt.svg";
//     case "png":
//     case "jpg":
//     case "jpeg":
//     case "gif":
//       return "/icons/myfiles/image.svg";
//     default:
//       return "/icons/myfiles/file.svg";
//   }
// };

// export const truncateFileName = (
//   fileName: any,
//   maxLength: number = 20
// ): any => {
//   const extIndex = fileName.lastIndexOf(".");
//   if (extIndex === -1 || extIndex === 0) return fileName;

//   const ext = fileName.slice(extIndex);
//   const name = fileName.slice(0, extIndex);

//   if (fileName.length <= maxLength) {
//     return fileName;
//   }

//   const truncatedName = name.slice(0, maxLength - ext.length - 3);
//   return `${truncatedName}...${ext}`;
// };

export const isMarkdown = (text: any) => {
  const markupPattern = /<\/?[a-z][\s\S]*>/i;
  const hasMarkup = markupPattern.test(text);
  return !hasMarkup;
};

export const organizations = [{ label: "RolesGpt", value: "rolesgpt" }];

export const dateOptions = [
  { label: "Last 24 hours", value: "last_24_hours" },
  { label: "Last 7 days", value: "last_7_days" },
  { label: "Last 15 days", value: "last_15_days" },
  { label: "Last 30 days", value: "last_30_days" },
  { label: "Last 3 months", value: "last_3_months" },
  { label: "Last 6 months", value: "last_6_months" },
  { label: "Last 12 months", value: "last_12_months" },
  { label: "All Data", value: "all_data" },
];

export const apps = [
  { label: "RolesGpt", value: "rolesgpt" },
  { label: "HR App", value: "HR App" },
];

export const emailFilter = [
  { label: "Select Mail Type", value: "" },
  { label: "Feedback", value: "Feedback" },
  { label: "Launch-1", value: "Launch-1" },
];

const parseDate = (str: string) => {
  const [day, month, year] = str.split("-").map(Number);
  return new Date(year, month - 1, day);
};

export const filterDataByDate = (
  data: any | { Sessions?: any[] } | null | undefined,
  selectedValue: { label: string; value: string },
  selectedTopic?: string | null | undefined
) => {
  if (data && typeof data === "object" && "Sessions" in data) {
    data = data.Sessions;
  }

  if (!Array.isArray(data) || data.length === 0)
    return {
      filteredData: [],
      newlyRegisteredUsers: [],
      totalRegisteredUsers: [],
      isNewUsers: false,
    };

  let startDate: Date | null = null;
  let endDate: Date | null = new Date();
  const now = new Date();
  const validEndDate = endDate ?? now;

  const newUserThreshold = new Date();
  newUserThreshold.setMonth(newUserThreshold.getMonth() - 30);

  const parseISODate = (dateStr: string): Date | null => {
    if (!dateStr) return null;
    const parsedDate = new Date(dateStr);
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const parseDDMMYYYY = (str: string): Date => {
    const [day, month, year] = str.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  if (selectedValue.value === "custom_date_range" && selectedValue.label) {
    const dateRange = selectedValue.label.split(" - ");
    if (dateRange.length === 2) {
      startDate = parseDDMMYYYY(dateRange[0]);
      endDate = parseDDMMYYYY(dateRange[1]);

      if (!isNaN(endDate.getTime())) {
        endDate.setHours(23, 59, 59, 999);
      }
    }
  } else {
    switch (selectedValue.value) {
      case "last_24_hours":
        startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        break;
      case "last_7_days":
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "last_15_days":
        startDate = new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000);
        break;
      case "last_30_days":
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "last_3_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);
        break;
      case "last_6_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 6);
        break;
      case "last_12_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 12);
        break;
      default:
        startDate = null;
    }
  }

  const dateFilteredData = data.filter((item) => {
    const dateField =
      item?.last_modified ??
      item?.last_session_created_at ??
      item?.created_at ??
      null;

    if (!dateField) return false;

    const itemDate = parseISODate(dateField);
    if (!itemDate) return false;

    return startDate && endDate
      ? itemDate >= startDate && itemDate <= endDate
      : startDate
      ? itemDate >= startDate
      : true;
  });

  const filteredData = selectedTopic
    ? selectedTopic === "Like"
      ? dateFilteredData.filter((item) => item.reaction === "like")
      : selectedTopic === "Dislike"
      ? dateFilteredData.filter((item) => item.reaction === "dislike")
      : selectedTopic === "Cumstom Comment"
      ? dateFilteredData.filter((item) => item.custom_feedback !== null)
      : dateFilteredData
    : dateFilteredData;

  const totalRegisteredUsers = data.filter((item) => {
    const dateField = item.created_at ?? null;
    if (!dateField) return false;
    const itemDate = parseISODate(dateField);
    return (
      itemDate !== null &&
      (!startDate || (itemDate >= startDate && itemDate <= validEndDate))
    );
  });

  const newlyRegisteredUsers = data.filter((item) => {
    const dateField = item.created_at ?? null;
    if (!dateField) return false;
    const createdDate = parseISODate(dateField);
    return (
      createdDate !== null &&
      createdDate >= newUserThreshold &&
      (!startDate || (createdDate >= startDate && createdDate <= validEndDate))
    );
  });

  const isNewUsers =
    ["last_24_hours", "last_7_days", "last_15_days"].includes(
      selectedValue.value
    ) ||
    (selectedValue.value === "custom_date_range" &&
      startDate !== null &&
      startDate >= newUserThreshold);

  return {
    filteredData,
    totalRegisteredUsers,
    newlyRegisteredUsers,
    isNewUsers,
  };
};

export const getDateRangeFromSelectedValue = (selectedValue: {
  label: string;
  value: string;
}): { startDate?: string; endDate?: string; isAllData?: boolean } | null => {
  const now = new Date();
  let startDate: Date | null = null;
  let endDate: Date = new Date(now);

  if (selectedValue.value === "all_data") {
    return { isAllData: true };
  }

  if (selectedValue.value === "custom_date_range" && selectedValue.label) {
    const [startLabel, endLabel] = selectedValue.label.split(" - ");
    if (startLabel && endLabel) {
      startDate = parseDate(startLabel);
      endDate = parseDate(endLabel);
      endDate.setHours(23, 59, 59, 999);
    }
  } else {
    switch (selectedValue.value) {
      case "last_24_hours":
        // startDate = new Date(now.getTime() - 24 * 60 * 60 * 1000);
        startDate = now;
        break;
      case "last_7_days":
        startDate = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
        break;
      case "last_15_days":
        startDate = new Date(now.getTime() - 15 * 24 * 60 * 60 * 1000);
        break;
      case "last_30_days":
        startDate = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        break;
      case "last_3_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);
        break;
      case "last_6_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 6);
        break;
      case "last_12_months":
        startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 12);
        break;
      default:
        return null;
    }
  }

  if (!startDate) return null;

  const formatDate = (date: Date) =>
    date.toLocaleDateString("en-GB").split("/").join("-");

  if (selectedValue.value === "last_24_hours") {
    return {
      startDate: formatDate(startDate),
    };
  }

  return {
    startDate: formatDate(startDate),
    endDate: formatDate(endDate),
  };
};

export interface Session {
  user_created_at: string;
  last_session_created_at: string;
  user_login_count: number;
}

// export const getNewAndReturningUsers = (
//   sessions: Session[] = [],
//   thresholdDays: number = 30
// ): { newUsers: Session[]; returningUsers: Session[] } => {
//   const now = new Date();
//   const thresholdDate = new Date(now);
//   thresholdDate.setDate(now.getDate() - thresholdDays);

//   const newUsers: Session[] = [];
//   const returningUsers: Session[] = [];

//   for (const session of sessions) {
//     const createdAt = new Date(session.user_created_at);
//     const lastSession = new Date(session.last_session_created_at);
//     const loginCount = session.user_login_count || 0;

//     const isNew = createdAt >= thresholdDate;
//     const isReturning =
//       createdAt < thresholdDate &&
//       (lastSession >= thresholdDate || loginCount > 1);

//     if (isNew) {
//       newUsers.push(session);
//     } else if (isReturning) {
//       returningUsers.push(session);
//     }
//   }

//   return { newUsers, returningUsers };
// };

// interface FilterItem {
//   created_at?: string;
//   last_modified?: string;
//   last_session_created_at?: string;
//   reaction?: string;
//   custom_feedback?: string | null;
//   user_agent: any;
// }

// interface FilterInput {
//   Sessions?: FilterItem[];
// }

// interface FilterResult {
//   filteredData: FilterItem[];
//   newlyRegisteredUsers: FilterItem[];
//   totalRegisteredUsers: FilterItem[];
//   isNewUsers: boolean;
// }

// export const filterDataByDate = (
//   data: FilterItem[] | FilterInput | null | undefined,
//   selectedValue: { label: string; value: string },
//   selectedTopic?: string | null | undefined
// ): FilterResult => {
//   // Extract Sessions if present
//   const sessionData: FilterItem[] =
//     data && typeof data === "object" && "Sessions" in data
//       ? data.Sessions ?? []
//       : Array.isArray(data)
//       ? data
//       : [];

//   if (sessionData.length === 0) {
//     return {
//       filteredData: [],
//       newlyRegisteredUsers: [],
//       totalRegisteredUsers: [],
//       isNewUsers: false,
//     };
//   }

//   const now = new Date();
//   let startDate: Date | null = null;
//   let endDate: Date | null = now;

//   const newUserThreshold = new Date();
//   newUserThreshold.setMonth(newUserThreshold.getMonth() - 1); // 1 month

//   const parseISODate = (dateStr: string): Date | null => {
//     const parsed = new Date(dateStr);
//     return isNaN(parsed.getTime()) ? null : parsed;
//   };

//   // Custom range
//   if (selectedValue.value === "custom_date_range" && selectedValue.label) {
//     const [start, end] = selectedValue.label.split(" - ");
//     startDate = new Date(start);
//     endDate = new Date(end);
//     if (!isNaN(endDate.getTime())) {
//       endDate.setHours(23, 59, 59, 999);
//     }
//   } else {
//     const dayMap: Record<string, number> = {
//       last_24_hours: 1,
//       last_7_days: 7,
//       last_15_days: 15,
//       last_30_days: 30,
//     };

//     if (dayMap[selectedValue.value]) {
//       startDate = new Date(
//         now.getTime() - dayMap[selectedValue.value] * 24 * 60 * 60 * 1000
//       );
//     } else {
//       switch (selectedValue.value) {
//         case "last_3_months":
//           startDate = new Date();
//           startDate.setMonth(startDate.getMonth() - 3);
//           break;
//         case "last_6_months":
//           startDate = new Date();
//           startDate.setMonth(startDate.getMonth() - 6);
//           break;
//         case "last_12_months":
//           startDate = new Date();
//           startDate.setMonth(startDate.getMonth() - 12);
//           break;
//       }
//     }
//   }

//   const dateInRange = (dateStr: string | undefined | null): boolean => {
//     if (!dateStr) return false;
//     const date = parseISODate(dateStr);
//     return (
//       !!date &&
//       (!startDate || date >= startDate) &&
//       (!endDate || date <= endDate)
//     );
//   };

//   const filteredByDate = sessionData.filter((item) =>
//     dateInRange(
//       item.last_modified ??
//         item.last_session_created_at ??
//         item.created_at ??
//         null
//     )
//   );

//   const filteredData = selectedTopic
//     ? selectedTopic === "Like"
//       ? filteredByDate.filter((item) => item.reaction === "like")
//       : selectedTopic === "Dislike"
//       ? filteredByDate.filter((item) => item.reaction === "dislike")
//       : selectedTopic === "Cumstom Comment"
//       ? filteredByDate.filter((item) => item.custom_feedback !== null)
//       : filteredByDate
//     : filteredByDate;

//   const totalRegisteredUsers = sessionData.filter((item) =>
//     dateInRange(item.created_at)
//   );

//   const newlyRegisteredUsers = sessionData.filter((item) => {
//     const date = parseISODate(item.created_at ?? "");
//     return (
//       date &&
//       date >= newUserThreshold &&
//       (!startDate || date >= startDate) &&
//       (!endDate || date <= endDate)
//     );
//   });

//   const isNewUsers =
//     ["last_24_hours", "last_7_days", "last_15_days"].includes(
//       selectedValue.value
//     ) ||
//     (selectedValue.value === "custom_date_range" &&
//       startDate !== null &&
//       startDate >= newUserThreshold);

//   return {
//     filteredData,
//     newlyRegisteredUsers,
//     totalRegisteredUsers,
//     isNewUsers,
//   };
// };

export const getNewAndReturningUsers = (
  sessions: Session[] = [],
  thresholdDays: number = 15
): { newUsers: Session[]; returningUsers: Session[] } => {
  const now = new Date();
  const thresholdDate = new Date(now);
  thresholdDate.setDate(now.getDate() - thresholdDays);

  const newUsers: Session[] = [];
  const returningUsers: Session[] = [];

  for (const session of sessions) {
    const createdAt = new Date(session.user_created_at);

    if (createdAt >= thresholdDate) {
      newUsers.push(session);
    } else {
      returningUsers.push(session);
    }
  }

  return { newUsers, returningUsers };
};

export const generateXAxisLabels = (
  selectedValue: { label: string; value: string } | null
) => {
  if (!selectedValue || !selectedValue.value) return [];

  const value = selectedValue.value;
  const now = new Date();

  if (value === "last_24_hours") {
    return Array.from({ length: 24 }, (_, i) => `Hour ${i + 1}`);
  }

  if (value.includes("days")) {
    const days = parseInt(value.replace(/\D/g, ""), 10);
    return Array.from({ length: days }, (_, i) => {
      const pastDate = new Date();
      pastDate.setDate(now.getDate() - (days - i - 1));
      return pastDate.toISOString().split("T")[0];
    });
  }

  if (value.includes("months")) {
    const months = parseInt(value.replace(/\D/g, ""), 10);
    return Array.from({ length: months }, (_, i) => {
      const pastMonth = new Date();
      pastMonth.setMonth(now.getMonth() - (months - i - 1));

      return pastMonth.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
    });
  }

  if (value === "last_12_months") {
    return Array.from({ length: 12 }, (_, i) => {
      const pastMonth = new Date();
      pastMonth.setMonth(now.getMonth() - (12 - i - 1));
      return pastMonth.toLocaleString("default", {
        month: "long",
        year: "numeric",
      });
    });
  }

  if (value === "custom_date_range" && selectedValue.label) {
    const dateRange = selectedValue.label.split(" - ");
    if (dateRange.length === 2) {
      const startDate = new Date(dateRange[0]);
      const endDate = new Date(dateRange[1]);

      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
        return ["Invalid Date"];
      }

      const dateLabels = [];
      let currentDate = new Date(startDate);

      while (currentDate <= endDate && currentDate <= now) {
        dateLabels.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + 1);
      }

      return dateLabels.length > 0 ? dateLabels : ["No Data"];
    }
  }

  return ["No Data"];
};

export const agentIds: Record<string, string> = {
  "Job Description Creation": "JD_Creation_Crew",
  "Job Interview Preparation": "Job_Interview_Crew",
  "Country Onboarding Specialist": "Country_Onboarding_Crew",
  "CHRO Comprehensive Intelligence": "CHRO_Comprehensive_Crew",
  "Candidate Screening": "Resume_Builder_Crew",
};

export const agentResIds: Record<string, string> = {
  "Job Description Creation": "jd_creation_crew",
  "Job Interview Preparation": "Job_Interview_Crew",
  "Country Onboarding Specialist": "country_onboarding_crew",
  "CHRO Comprehensive Intelligence": "CHRO_Comprehensive_Crew",
  "Candidate Screening": "recruitment_crew",

  JD_Creation_Crew: "jd_creation_crew",
  Job_Interview_Crew: "interview_preparation_crew",
  Country_Onboarding_Crew: "country_onboarding_crew",
  CHRO_Comprehensive_Crew: "chro_comprehensive_crew",
  Resume_Builder_Crew: "recruitment_crew",
};

export const getAgentIconKey = (agentName?: string) => {
  if (!agentName) return "jd_creation_crew";
  return (
    agentResIds[agentName] ||
    agentResIds[agentName.trim()] ||
    "jd_creation_crew"
  );
};

export const agentLabels: Record<string, string> = {
  jd_creation_crew: "Job Description Creation",
  interview_preparation_crew: "Job Interview Preparation",
  country_onboarding_crew: "Country Onboarding Specialist",
  chro_comprehensive_crew: "CHRO Comprehensive Intelligence",
  recruitment_crew: "Candidate Screening",
};

export function fixMalformedJsonString(raw: string): string {
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "object" && Object.keys(parsed).length > 0) {
      return JSON.stringify(parsed, null, 2);
    }
  } catch {
    console.warn("⚠️ raw is not valid JSON, attempting to sanitize...");
  }

  let cleaned = raw
    .replace(/```json|```/gi, "")
    .replace(/Here is the response.*?:/gi, "")
    .replace(/\{\{\s*(.*?)\s*\}\}/g, "{$1}")
    .replace(/([{,])\s*'([^']+?)'\s*:/g, '$1"$2":')
    .replace(/:\s*'([^']*?)'/g, ': "$1"')
    .replace(/'([^']*?)'/g, '"$1"')
    .replace(/“|”/g, '"')
    .replace(/‘|’/g, "'")
    .replace(/\\n/g, " ")
    .replace(/\n/g, " ")
    .replace(/\s{2,}/g, " ");

  // cleaned = cleaned.replace(
  //   /"description"\s*:\s*"([^"]*?\{[^"]+?\}[^"]*?)"/g,
  //   (_, innerContent) => {
  //     const escaped = innerContent.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
  //     return `"description": "${escaped}"`;
  //   }
  // );

  try {
    const parsed = JSON.parse(cleaned);
    if (typeof parsed === "object" && Object.keys(parsed).length > 0) {
      return JSON.stringify(parsed, null, 2);
    } else {
      return "";
    }
  } catch (e) {
    console.warn("⚠️ fixMalformedJsonString - JSON parse failed:", e);
    return "";
  }
}

export const isLikelyUid = (input: string): boolean => {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\s?\|/i.test(
    input
  );
};

export function extractUidAndMessage(text: string): UidAndMessage {
  const index = text.indexOf("|");
  if (index !== -1) {
    return {
      uid: text.slice(0, index).trim(),
      message: text.slice(index + 1).trim(),
    };
  }
  return { uid: "", message: text };
}

export function extractFirstJsonObject(text: string): {
  json: string | null;
  rest: string;
  debug: {
    codeBlockRanges: [number, number][];
    foundJsonAt: number | null;
    rawCandidate: string | null;
  };
} {
  const codeBlockRegex = /```[\s\S]*?```|`[^`\n]*`/g;
  const codeBlockRanges: [number, number][] = [];

  let match;
  while ((match = codeBlockRegex.exec(text)) !== null) {
    codeBlockRanges.push([match.index, match.index + match[0].length]);
  }

  const isInsideCodeBlock = (position: number): boolean => {
    return codeBlockRanges.some(
      ([start, end]) => position >= start && position < end
    );
  };

  for (let i = 0; i < text.length; i++) {
    if (isInsideCodeBlock(i)) continue;

    if (text[i] === "{" || text[i] === "[") {
      let stack = [text[i]];
      let end = i + 1;
      let inString = false;
      let escapeNext = false;

      while (stack.length && end < text.length) {
        if (isInsideCodeBlock(end)) {
          end++;
          continue;
        }

        const char = text[end];

        if (escapeNext) {
          escapeNext = false;
          end++;
          continue;
        }

        if (char === "\\") {
          escapeNext = true;
          end++;
          continue;
        }

        if (char === '"') {
          inString = !inString;
          end++;
          continue;
        }

        if (!inString) {
          if (char === "{" || char === "[") {
            stack.push(char);
          } else if (
            (char === "}" && stack[stack.length - 1] === "{") ||
            (char === "]" && stack[stack.length - 1] === "[")
          ) {
            stack.pop();
          }
        }

        end++;
      }

      if (stack.length === 0) {
        const candidate = text.slice(i, end).trim();

        try {
          const parsed = JSON.parse(candidate);

          if (typeof parsed === "object" && parsed !== null) {
            return {
              json: JSON.stringify(parsed, null, 2),
              rest: text.slice(0, i) + text.slice(end),
              debug: {
                codeBlockRanges,
                foundJsonAt: i,
                rawCandidate: candidate,
              },
            };
          }
        } catch (error) {
          continue;
        }
      }
    }
  }

  return {
    json: null,
    rest: text,
    debug: {
      codeBlockRanges,
      foundJsonAt: null,
      rawCandidate: null,
    },
  };
}

export const getFileIcon = (filename: any) => {
  const ext = filename?.toLowerCase().split(".").pop();
  switch (ext) {
    case "pdf":
      return "/icons/myfiles/pdfv1.svg";
    case "doc":
    case "docx":
      return "/icons/myfiles/wordv1.svg";
    case "ppt":
    case "pptx":
      return "/icons/myfiles/pptv1.svg";
    case "xls":
    case "xlsx":
      return "/icons/myfiles/excelv1.svg";
    case "txt":
      return "/icons/myfiles/txtv1.svg";
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
      return "/icons/myfiles/imagev1.svg";
    default:
      return "/icons/myfiles/pdfv1.svg";
  }
};

export const handleGetFiles = async (
  filename: string,
  database: string,
  getFilesApi: any,
  userId: string,
  userNameEmail: string,
  isDownload?: boolean
) => {
  try {
    // addToast("info", "Please wait, processing the file...");

    const blob = await getFilesApi.mutateAsync({
      filename,
      username: userId,
      userNameEmail: userNameEmail,
      database,
    });

    if (blob instanceof Blob) {
      const fileUrl = URL.createObjectURL(blob);

      if (isDownload) {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        URL.revokeObjectURL(fileUrl);

        // addToast("success", "File downloaded successfully.");
      } else {
        const newTab = window.open(fileUrl, "_blank");
        if (newTab) {
          // addToast("success", "File opened successfully in a new tab.");
        } else {
          // addToast(
          //   "error",
          //   "Failed to open new tab (possibly blocked by browser)."
          // );
        }
      }

      setTimeout(() => URL.revokeObjectURL(fileUrl), 10000);
    } else {
      // addToast("error", "Invalid file format. Please try again.");
    }
  } catch (error) {
    console.error("Error retrieving file:", error);
    // addToast("error", "Failed to retrieve file");
  }
};

export const truncateFileName = (fileName: any, maxLength?: number) => {
  const extIndex = fileName.lastIndexOf(".");
  if (extIndex === -1 || extIndex === 0) {
    if (maxLength) {
      maxLength = maxLength - 3;
      return fileName.slice(0, maxLength - 3) + "...";
    } else {
      return fileName.slice(0, maxLength);
    }
  }

  const ext = fileName.slice(extIndex);
  const name = fileName.slice(0, extIndex);

  if (maxLength === undefined) {
    maxLength = 20;
  }
  if (fileName.length <= maxLength) {
    return fileName;
  }

  const truncatedName = name.slice(0, maxLength - ext.length - 3);

  return `${truncatedName}...${ext}`;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const convertMarkdownToHtml = async (markdown: string) => {
  let html = markdown;

  // Convert headers
  html = html.replace(
    /^### (.*$)/gm,
    '<h3 style="font-size: 1.2em; font-weight: bold; margin: 16px 0 8px 0; color: #333;">$1</h3>'
  );
  html = html.replace(
    /^## (.*$)/gm,
    '<h2 style="font-size: 1.4em; font-weight: bold; margin: 20px 0 12px 0; color: #333;">$1</h2>'
  );
  html = html.replace(
    /^# (.*$)/gm,
    '<h1 style="font-size: 1.6em; font-weight: bold; margin: 24px 0 16px 0; color: #333;">$1</h1>'
  );

  // Convert bold text
  html = html.replace(
    /\*\*(.*?)\*\*/g,
    '<strong style="font-weight: bold;">$1</strong>'
  );
  html = html.replace(
    /__(.*?)__/g,
    '<strong style="font-weight: bold;">$1</strong>'
  );

  // Convert italic text
  html = html.replace(/\*(.*?)\*/g, '<em style="font-style: italic;">$1</em>');
  html = html.replace(/_(.*?)_/g, '<em style="font-style: italic;">$1</em>');

  // Convert lists
  html = html.replace(/^\* (.*$)/gm, '<li style="margin: 4px 0;">$1</li>');
  html = html.replace(/^- (.*$)/gm, '<li style="margin: 4px 0;">$1</li>');
  html = html.replace(/^\d+\. (.*$)/gm, '<li style="margin: 4px 0;">$1</li>');

  // Wrap consecutive list items in ul/ol tags
  html = html.replace(/(<li.*?<\/li>\s*)+/g, (match) => {
    return `<ul style="margin: 12px 0; padding-left: 24px;">${match}</ul>`;
  });

  // Convert line breaks to paragraphs
  html = html.replace(
    /\n\n/g,
    '</p><p style="margin: 8px 0; line-height: 1.6;">'
  );
  html = html.replace(/\n/g, "<br>");

  // Wrap in paragraphs if not already wrapped
  if (!html.startsWith("<")) {
    html = `<p style="margin: 8px 0; line-height: 1.6;">${html}</p>`;
  }

  return html;
};

export type Status = "new" | "active" | "inactive" | undefined;

export function getFilteredStatus(search: string): Status {
  const p = new URLSearchParams(search);
  const newQ = p.get("new_users") ?? p.get("new_user");
  const st = p.get("status");

  if (newQ === "new" || newQ === "true" || newQ === "1") return "new";
  if (st === "active" || st === "true" || st === "1") return "active";
  if (st === "inactive" || st === "false" || st === "0") return "inactive";
  return undefined;
}

export const services: ServiceStatus[] = [
  {
    key: "Chat API",
    status: "UP",
    uptime30d: 99.96,
    latencyMs: 182,
    incidents30d: 0,
  },
  {
    key: "HR Agent Name API",
    status: "UP",
    uptime30d: 99.9,
    latencyMs: 210,
    incidents30d: 1,
  },
  {
    key: "Auth API",
    status: "UP",
    uptime30d: 100.0,
    latencyMs: 95,
    incidents30d: 0,
  },
  {
    key: "Files API",
    status: "DOWN",
    uptime30d: 99.1,
    latencyMs: null,
    incidents30d: 2,
  },
  {
    key: "Emailer API",
    status: "UP",
    uptime30d: 99.7,
    latencyMs: 240,
    incidents30d: 1,
  },
];
